import Car from 'public/icons/car.svg?react';
import { FC } from 'react';
import { cvaIcon } from '~/shared/styles/IconStyles';
import {
  cvaCarNumberExample,
  cvaCarNumberExampleInner,
} from '~/shared/ui/CarNumberExample/CarNumberExampleStyles';

interface Props {
  text: string;
  theme?: 'dark' | 'darker';
}

export const CarNumberExample: FC<Props> = ({ text, theme = 'dark' }) => {
  return (
    <div className={cvaCarNumberExample({ theme })}>
      <div className={cvaCarNumberExampleInner()}>
        <Car className={cvaIcon({ iconSize: 'common' })} />
        <span>{text.toUpperCase()}</span>
      </div>
    </div>
  );
};
